import { SVGProps } from '@components/Icon/types';

export const Email = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1, 3)">
      <path
        d="M21.2793 1.75086C21.7326 2.41415 22 3.22031 22 4.091V13.909C22 16.1684 20.2091 18 18 18H4C1.79086 18 0 16.1684 0 13.909V4.091C9.7482e-08 3.22052 0.266569 2.41406 0.719727 1.75086L7.50488 9.47043C9.37215 11.5943 12.6279 11.5944 14.4951 9.47043L21.2793 1.75086Z"
        fill={fill}
      />
      <path
        d="M18 0C18.8521 0 19.6412 0.27366 20.29 0.738098C20.2866 0.741862 20.2827 0.745227 20.2793 0.749084L13.4541 8.51359C12.1431 10.0046 9.85691 10.0046 8.5459 8.51359L1.7207 0.749084C1.71722 0.745125 1.71253 0.741959 1.70898 0.738098C2.35798 0.273374 3.14762 4.39138e-08 4 0H18Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'email';
